var AudioManager = {
	
	sounds:{},
	lastUrl:"",
	queue:[],
	cycle: 0,

	load :function(url) {
		if (!AudioManager.sounds.hasOwnProperty(url)) {
			AudioManager.sounds[url] = new AudioPlayer("speechtip");
			AudioManager.sounds[url].loadSound(url);
		}
	},

	play:function(url, vol) {
		if (this.lastUrl != url && this.lastUrl != "") {
			for(var p in AudioManager.queue) {
				AudioManager.queue[p].stop();
			}
		}

		console.log(AudioManager.cycle);

		if (AudioManager.queue.length <= AudioManager.cycle) {
			AudioManager.queue.push(new AudioPlayer("speechtip"));
		}

		AudioManager.queue[AudioManager.cycle].loadSound(url);
		AudioManager.queue[AudioManager.cycle].playWhenLoaded();
		AudioManager.queue[AudioManager.cycle].setVolume(vol);

		var ret = AudioManager.queue[AudioManager.cycle];

		AudioManager.cycle ++;
		if (AudioManager.cycle > 2) AudioManager.cycle = 0;

		this.lastUrl = url;

		return ret;
	},

	playDefer:function(url, vol) {
		if (this.lastUrl != url && this.lastUrl != "" && AudioManager.sounds[this.lastUrl] != undefined) {
			AudioManager.sounds[this.lastUrl].stop();
		}

		if (AudioManager.sounds.hasOwnProperty(url)) {
			AudioManager.sounds[url].playWhenLoaded();
			AudioManager.sounds[url].setVolume(vol);
		} else {
			AudioManager.load(url);
			AudioManager.sounds[url].playWhenLoaded();
			AudioManager.sounds[url].setVolume(vol);
		}

		this.lastUrl = url;
		return AudioManager.sounds[url];
	},

	player: function(url) {
		return AudioManager.sounds[url];
	},

	setAllVolumes: function(v) {
		for(var s in AudioManager.sounds) {
			AudioManager.sounds[s].setVolume(v);
		}
	}
}